<template>

  <div class="overflow-hidden">
    <div class="flex justify-space-between">
      <h3 class="form-section-header mb-0" style="margin-left: 0;">
        Online devices
      </h3>
      <el-button
        slot="reference"
        type="primary"
        @click="queryRegistrations"
      >
        Load online devices
      </el-button>
    </div>
    <vxe-table
      round
      class="mt-10"
      border="inner"
      height="150px"
      :loading="devicesLoading"
      :data="devices"
      show-overflow
      empty-text="No Data"
    >
      <vxe-table-column
        field="agent"
        title="User Agent"
        min-width="350"
        show-header-overflow
        show-overflow
      />
      <vxe-table-column
        field="address"
        title="Address"
        min-width="350"
        show-header-overflow
        show-overflow
      />
      <vxe-table-column
        field="expires"
        title="Expires"
        min-width="75"
        show-header-overflow
        show-overflow
      />
      <vxe-table-column
        field="received"
        title="Received"
        min-width="200"
        show-header-overflow
        show-overflow
      />
      <vxe-table-column
        field="path"
        title="Path"
        min-width="500"
        show-header-overflow
        show-overflow
      />
      <vxe-table-column
        field="lastKeepAlive"
        title="Last Keep Alive"
        min-width="150"
        show-header-overflow
        show-overflow
      />
      <vxe-table-column
        field="serverId"
        title="Server Id"
        min-width="75"
        show-header-overflow
        show-overflow
      />
    </vxe-table>
  </div>

</template>

<script>

  import feathersClient from "../../../../feathers/feathers-client";

  export default {
    name: 'MyDevices',
    data () {
      return {
        devices: [],
        devicesLoading: true
      }
    },
    computed: {
      user(){
        return this.$store.state.auth.user;
      }
    },
    methods: {
      queryRegistrations() {

        this.devicesLoading = true;
        this.devices = [];
        feathersClient
          .service("sbc-management")
          .create({
            command: "kamExtension",
            peerName: this.user.myExtension.peerName
          })
          .then(res => {
            const { code } = res;

            if (!code) {
              this.devices = res.map(item => ({
                agent: item.Contact["User-Agent"],
                expires: item.Contact.Expires,
                address: item.Contact.Address,
                received: item.Contact.Received,
                path: item.Contact.Path,
                serverId: item.Contact["Server-Id"],
                lastKeepAlive: item.Contact["Last-Keepalive"]
              }));
            } else {
              this.$message({
                message: "No registered devices found!",
                duration: 1000
              });
            }
            this.devicesLoading = false;
          })
          .catch(() => {
            this.devices = [];
            this.devicesLoading = false;
          });
      },
    },
    mounted(){
      this.queryRegistrations();
    }
  }

</script>
